import { GroupData, LanguageNameSpaces } from "@shared/types";
import Flex from "common/Boxes/Flex";
import Title from "common/Typography/Title";
import Text from "common/Typography/Text";
import LinkButton from "common/Buttons/LinkButton";
import React from "react";
import styled from "styled-components";
import { useGroupSubscriptionData } from "features/settings/common/hooks";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface GroupSubscriptionProps {
  groupData: GroupData;
  onCancelAutoRenewal: () => void;
}

const GroupSubscription = ({
  groupData,
  onCancelAutoRenewal,
}: GroupSubscriptionProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const { actionButton, expirationText } = useGroupSubscriptionData(
    groupData,
    onCancelAutoRenewal,
    t("group_subscriptions.cancel_auto_renewal")
  );

  return (
    <SubscriptionCard key={groupData.id}>
      <Flex $alignItems="center" style={{ minHeight: 45 }}>
        <NameAndExpirationWrapper>
          <Title level={4}>{groupData.name}</Title>
          <Text type="secondary">{expirationText}</Text>
        </NameAndExpirationWrapper>
        <GroupImage src={groupData.image} style={{ marginLeft: 6 }} />
      </Flex>
      {actionButton && (
        <ButtonWrapper>
          <LinkButton
            type="link"
            style={{
              width: "100%",
              marginTop: 4,
              padding: 0,
            }}
            onClick={actionButton.onClick}
          >
            {actionButton.text}
          </LinkButton>
        </ButtonWrapper>
      )}
    </SubscriptionCard>
  );
};

export default GroupSubscription;

const SubscriptionCard = styled.div`
  padding: 12px 16px;
  width: 100%;
  border-radius: 12px;
  border: ${(p) => p.theme.borders.medium};
`;
const NameAndExpirationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const GroupImage = styled.img<{ $size?: number }>`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
`;
const ButtonWrapper = styled.div`
  margin-top: 16px;
  padding-top: 4px;
  border-top: ${(p) => p.theme.borders.light};
`;
